// This file was auto-generated by Fern from our API Definition.
export const FolderKind = {
    Applications: "applications",
};
